import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { SetViewersCanCommentOnCards } from '../../../api/commands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetViewersCanComment extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetViewersCanComment';

    public constructor(public canComment: boolean) {
        super(SetViewersCanComment.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetViewersCanComment): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new SetViewersCanCommentOnCards(state.id, action.canComment),
    });
};

const reducer = (state: StorymapState, action: SetViewersCanComment): void => {
    state.viewersCanCommentOnCards = action.canComment;
};

//@ts-ignore
registerMiddleware(SetViewersCanComment.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetViewersCanComment.ACTION_TYPE, reducer);
